import { render } from "./SuccessAlert.vue?vue&type=template&id=914f7244&scoped=true"
import script from "./SuccessAlert.vue?vue&type=script&lang=js"
export * from "./SuccessAlert.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/whisk/whisk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-914f7244"]])

export default __exports__